var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-container-content", attrs: { id: "consignerInfo" } },
    [
      _c(
        "div",
        { staticClass: "box-btn" },
        [
          _vm.titleFlag == ""
            ? _c("div", { staticClass: "filter-container-title" }, [
                _vm._v(_vm._s(_vm.$t("home.notifierInfo"))),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.titleFlag == "2"
            ? _c("div", { staticClass: "filter-container-title" }, [
                _vm._v(_vm._s(_vm.$t("home.notifierInfoPrevious"))),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.titleFlag == "3"
            ? _c("div", { staticClass: "filter-container-title" }, [
                _vm._v(_vm._s(_vm.$t("home.notifierInfoCurrent"))),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "btn-plain-primary",
              attrs: { type: "primary", disabled: _vm.CNXMNDisabled },
              on: { click: _vm.handleTongbu },
            },
            [_vm._v(_vm._s(_vm.$t("home.bittonTop")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.form.webBkCustomerComs
        ? _c(
            "div",
            { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
            [
              _vm._l(_vm.getCatalogComs(), function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    class: {
                      required:
                        (item.sequence === "1" ||
                          (!_vm.validateNull(_vm.form.pod) &&
                            _vm.form.pod.startsWith("CN") &&
                            item.sequence === "9") ||
                          item.sequence === "8" ||
                          (!_vm.validateNull(_vm.form.pol) &&
                            _vm.form.pol.startsWith("TH") &&
                            (item.sequence === "7" || item.sequence === "8")) ||
                          (!_vm.validateNull(_vm.form.pod) &&
                            _vm.form.pod.startsWith("CN") &&
                            (_vm.form.pod !== "CNSHA" || _vm.sameAsConsignee) &&
                            item.sequence === "15") ||
                          (!_vm.validateNull(_vm.form.pod) &&
                            _vm.form.pod.startsWith("JP") &&
                            (item.sequence === "2" ||
                              item.sequence === "7" ||
                              item.sequence === "8"))) &&
                        _vm.isShowRequired,
                    },
                    staticStyle: { "flex-basis": "45%" },
                  },
                  [
                    index === 0 || index === 1
                      ? _c(
                          "el-form-item",
                          {
                            class: _vm.inputClass(
                              "catalogContent" + item.sequence
                            ),
                            attrs: {
                              prop: "customerName",
                              label: _vm.showName(item),
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "highlight-container" },
                              [
                                _c("light-input", {
                                  staticClass: "cusInput",
                                  attrs: {
                                    "highlight-enabled": true,
                                    "is-editable":
                                      !_vm.isDisable && !_vm.CNXMNDisabled,
                                    "max-length": 2000,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handleChangePeople(item)
                                    },
                                  },
                                  nativeOn: {
                                    dblclick: function ($event) {
                                      _vm.openDialog(2000)
                                      _vm.handleText(item, index)
                                    },
                                  },
                                  model: {
                                    value: item.catalogContent,
                                    callback: function ($$v) {
                                      _vm.$set(item, "catalogContent", $$v)
                                    },
                                    expression: "item.catalogContent",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    (index < 8 && index > 2) || (index >= 8 && index <= 10)
                      ? _c(
                          "el-form-item",
                          {
                            class: _vm.inputClass(
                              "catalogContent" + item.sequence
                            ),
                            attrs: {
                              prop: "customerName",
                              label: _vm.showName(item),
                            },
                          },
                          [
                            _c(
                              "el-input",
                              {
                                directives: [
                                  { name: "uppercase", rawName: "v-uppercase" },
                                  { name: "trim", rawName: "v-trim" },
                                  { name: "fth", rawName: "v-fth" },
                                  {
                                    name: "byte-length",
                                    rawName: "v-byte-length",
                                    value: 2000,
                                    expression: "2000",
                                  },
                                ],
                                attrs: {
                                  onblur:
                                    "this.value = this.value.toUpperCase()",
                                  disabled:
                                    (index === 7 &&
                                      !_vm.validateNull(_vm.form.pol) &&
                                      _vm.form.pol.startsWith("TH")) ||
                                    _vm.CNXMNDisabled,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.handleChangePeople(item)
                                  },
                                },
                                nativeOn: {
                                  copy: function ($event) {
                                    return _vm.onCopy($event, item)
                                  },
                                },
                                model: {
                                  value: item.catalogContent,
                                  callback: function ($$v) {
                                    _vm.$set(item, "catalogContent", $$v)
                                  },
                                  expression: "item.catalogContent",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-input__icon icon-point",
                                  class: {
                                    "el-icon-document":
                                      item.sequence === "1" ||
                                      item.sequence === "2",
                                  },
                                  attrs: { slot: "suffix" },
                                  on: {
                                    click: function ($event) {
                                      _vm.openDialog()
                                      _vm.handleText(item, index)
                                    },
                                  },
                                  slot: "suffix",
                                }),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    index === 2
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "customerName",
                              label: _vm.showName(item),
                            },
                          },
                          [
                            _c("glCountry", {
                              class: _vm.inputClass(
                                "catalogContent" + item.sequence
                              ),
                              attrs: { disabled: _vm.CNXMNDisabled },
                              model: {
                                value: item.catalogContent,
                                callback: function ($$v) {
                                  _vm.$set(item, "catalogContent", $$v)
                                },
                                expression: "item.catalogContent",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    index === 12 && _vm.isShow
                      ? _c(
                          "el-button",
                          {
                            staticClass: "openClick",
                            attrs: { type: "text", disabled: false },
                            on: { click: _vm.handleOpen },
                          },
                          [
                            _vm._v(_vm._s(_vm.$t("home.expandOthers"))),
                            _c("i", { staticClass: "el-icon-arrow-down" }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    index === 13 && _vm.isShow
                      ? _c("div", { staticClass: "openClick" })
                      : _vm._e(),
                    _vm._v(" "),
                    index === 12 && !_vm.isShow
                      ? _c(
                          "div",
                          { staticClass: "openClick" },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "openClick",
                                attrs: {
                                  type: "text",
                                  disabled: _vm.isMaterials,
                                },
                                on: { click: _vm.handleOpen },
                              },
                              [
                                _vm._v(_vm._s(_vm.$t("home.packUpOthers"))),
                                _c("i", { staticClass: "el-icon-arrow-up" }),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    index === 13 && !_vm.isShow
                      ? _c("div", { staticClass: "openClick" })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isShow && index >= 12
                      ? _c(
                          "el-form-item",
                          {
                            class: _vm.inputClass(
                              "catalogContent" + item.sequence
                            ),
                            attrs: {
                              prop: "customerName",
                              label: _vm.showName(item),
                            },
                          },
                          [
                            _c("el-input", {
                              directives: [
                                { name: "uppercase", rawName: "v-uppercase" },
                                { name: "trim", rawName: "v-trim" },
                                { name: "fth", rawName: "v-fth" },
                                {
                                  name: "byte-length",
                                  rawName: "v-byte-length",
                                  value: 2000,
                                  expression: "2000",
                                },
                              ],
                              attrs: {
                                onblur: "this.value = this.value.toUpperCase()",
                                disabled: _vm.CNXMNDisabled,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleChangePeople(item)
                                },
                              },
                              model: {
                                value: item.catalogContent,
                                callback: function ($$v) {
                                  _vm.$set(item, "catalogContent", $$v)
                                },
                                expression: "item.catalogContent",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c("msg-check-text-dialog", {
                ref: "myDialog",
                attrs: { catalogContent: _vm.catalogContent },
                on: { confirm: _vm.confirm },
              }),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }